import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { ResponseEnvelope } from '../models/response-envelope';

/**
 * Thin client for the self-scoped avatar endpoints. Holds no state — caching, the per-login load
 * and cross-tab sync all live in AvatarService, so this stays trivially testable.
 *
 * The endpoints are id-less on purpose: they live on ProfileController rather than UserController,
 * which is class-level ROLE_ADMIN and would lock out every non-admin staff member.
 */
@Injectable({ providedIn: 'root' })
export class AvatarApiService {
  private base = `${environment.apiUrl}/v2/profile/avatar`;

  constructor(private http: HttpClient) {}

  /** The current user's avatar data URL, or null when none is set. */
  get(): Observable<string | null> {
    return this.http
      .get<ResponseEnvelope<string | null>>(this.base, { withCredentials: true })
      .pipe(map(res => res.data ?? null));
  }

  set(dataUrl: string): Observable<void> {
    return this.http
      .put<void>(this.base, { image: dataUrl }, { withCredentials: true })
      .pipe(map(() => undefined));
  }

  clear(): Observable<void> {
    return this.http
      .delete<void>(this.base, { withCredentials: true })
      .pipe(map(() => undefined));
  }
}
